import { getReactions } from './get-reactions';
import { LikeReactionPayload, ReactionContextType, ReactionType } from '../../../typings';

export interface GetTeacherClessonLikesRequestData {
    clessonIds: number[];
    teacherId: number;
}

export function getTeacherClessonLikes(request: GetTeacherClessonLikesRequestData) {
    return getReactions<LikeReactionPayload>({
        reaction_type: ReactionType.LIKE,
        receiver_id: [request.teacherId],
        context_id: request.clessonIds,
        context_type: ReactionContextType.CLESSON,
    });
}
